<app-form title="Please complete the form below and we will contact you shortly."
          additionalText="By submitting this form, I consent to having this website to store my information so they can respond to my inquiry."
          [formDefinitionId]="formDefinitionId" (onSubmit)="executeAction($event)">
</app-form>

<app-modal *ngIf="successCode == 2" [modal]="successModal" (onClosed)="succesModalClosed()"></app-modal>
<app-modal *ngIf="successCode == 1" [modal]="failedModal" (onClosed)="failedModalClosed()"></app-modal>

